var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Card WineCellar",on:{"click":_vm.goTo}},[_c('h3',[_vm._v(_vm._s(_vm.$t('virtual-wine-cellar')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }